import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../../../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { link } from "fs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationService } from "src/app/services/notification.service";
import { CustomSnackbarComponent } from "src/app/shared/components/custom-snackbar/custom-snackbar.component";
import { AuthService } from "src/app/providers/auth.service";

@Component({
  selector: "sm-todays-bookings",
  templateUrl: "./todays-bookings.component.html",
  styleUrls: ["./todays-bookings.component.scss"],
})
export class TodaysBookingsComponent implements OnInit, OnDestroy {
  repeatArray: any;
  todaysBookingData: any = [];
  toshowData: boolean = true;
  loader: boolean = false;
  _apisub: Subscription;
  constructor(
    private _apiservice: ApiService,
    private router: Router,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private notificationService: NotificationService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {
    this.listenForNewBookingUpdates();
    this.listenForBookingStatusUpdates();
    this.listenForMemberAttendance();
    this.listenForBookingAssignmentUpdates();
    this.listenForMemberBookingStatusUpdate();
    this.listenForMemberBookingAssignmentUpdates();
    this._apisub = this._apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_TODAY_BOOKINGS_FOR_DASHBOARD
      ) {
        this.todaysBookingData = [];
        if (resdata.result) {
          resdata.result.forEach((element: any) => {
            if (element.data_type == 1) {
              if (element.booking_type == 0) {
                element.bookingType = "Home service";
              } else if (element.booking_type == 1) {
                element.bookingType = "Shop service";
              } else if (element.booking_type == 2) {
                element.bookingType = "Virtual service";
              }

              if (
                element.appointment_status == 0 ||
                element.appointment_status == 1 ||
                element.appointment_status == 2
              ) {
                element.bookingStat = "New";
              } else if (element.appointment_status == 3) {
                element.bookingStat = "In-progress";
              } else if (element.appointment_status == 4) {
                element.bookingStat = "Completed";
              } else if (element.appointment_status == 5) {
                element.bookingStat = "Confirmed";
              } else if (element.appointment_status == 6) {
                element.bookingStat = "Cancelled";
              } else if (element.appointment_status == 7) {
                element.bookingStat = "Assigned";
              } else if (element.appointment_status == 8) {
                element.bookingStat = "Cancelled";
              } else if (element.appointment_status == 9) {
                element.bookingStat = "In-progress";
              } else {
                element.bookingStat = "--";
              }

              if (
                element.booking_start_time &&
                element.booking_start_time != null
              ) {
                element.booking_start_time = element.booking_start_time.slice(
                  0,
                  5
                );
              }
              if (
                element.booking_end_time &&
                element.booking_end_time != null
              ) {
                element.booking_end_time = element.booking_end_time.slice(0, 5);
              }

              element.phone =
                element.country_code + " " + element.customer_phone;
              element.time =
                (element.booking_start_time ?? "") +
                " - " +
                (element.booking_end_time ?? "");

              if(element.booking_address){
                element.booking_address = typeof element.booking_address == 'string' ? JSON.parse(element.booking_address) : element.booking_address
              }

              this.todaysBookingData.push(element);
            } else if (element.data_type == 2) {
              if (element.booking_type == 0) {
                element.bookingType = "Home service";
              } else if (element.booking_type == 1) {
                element.bookingType = "Shop service";
              } else if (element.booking_type == 2) {
                element.bookingType = "Virtual service";
              }

              if (element.appointment_status == 0) {
                element.bookingStat = "Absent";
              } else {
                if (element.session_status == 1) {
                  element.bookingStat = "Assigned";
                } else if (element.session_status == 2) {
                  element.bookingStat = "In-progress";
                } else if (element.session_status == 3) {
                  element.bookingStat = "Completed";
                } else if (element.appointment_status == 1) {
                  element.bookingStat = "Present";
                } else {
                  element.bookingStat = "Membership";
                }
              }

              if (
                element.booking_start_time &&
                element.booking_start_time != null
              ) {
                element.booking_start_time = element.booking_start_time.slice(
                  0,
                  5
                );
              }
              if (
                element.booking_end_time &&
                element.booking_end_time != null
              ) {
                element.booking_end_time = element.booking_end_time.slice(0, 5);
              }

              element.phone =
                element.country_code + " " + element.customer_phone;
              element.time =
                (element.booking_start_time ?? "") +
                " - " +
                (element.booking_end_time ?? "");
              this.todaysBookingData.push(element);
            } else if (element.data_type == 3) {
              if (element.booking_type == 0) {
                element.bookingType = "Home service";
              } else if (element.booking_type == 1) {
                element.bookingType = "In-premise service";
              } else if (element.booking_type == 2) {
                element.bookingType = "Virtual service";
              }
              element.phone =
                element.country_code + " " + element.customer_phone;

              if (element.appointment_status == 1) {
                element.bookingStat = "New query";
              } else if (element.appointment_status == 2) {
                element.bookingStat = "Query in progress";
              } else if (element.appointment_status == 3) {
                element.bookingStat = "Marked enrolled";
              } else if (element.appointment_status == 4) {
                element.bookingStat = "Query cancelled";
              } else if (element.appointment_status == 5) {
                element.bookingStat = "Query enrolled";
              }
              element.employee_name = "---";
              if (element.enrolled_member_timings) {
                element.enrolled_member_timings =
                  typeof element.enrolled_member_timings == "string"
                    ? JSON.parse(element.enrolled_member_timings)
                    : element.enrolled_member_timings;
              }
              element.time = element.enrolled_member_timings
                ? this.formatSchedule(element.enrolled_member_timings)
                : "---";
              this.todaysBookingData.push(element);
            }
          });
        }
        if (this.todaysBookingData.length < 4) {
          this.repeatArray = new Array(4 - this.todaysBookingData.length);
        }
        this.loader = false;
      }
    });
  }

  ngOnInit(): void {
    this.loader = true;
    this._apiservice.getTodaysBookingsForDashboard("4", "1");
  }
  openAllTodaysBookings() {
    this.router.navigate(["all-today-bookings"]);
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Today's bookings",
      },
    });
  }

  private newbookingsubscription: Subscription = new Subscription();
  listenForNewBookingUpdates() {
    this.newbookingsubscription = this.notificationService
      .getNotificationByType("newBooking")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only

            this._apiservice.getTodaysBookingsForDashboard("4", "1");

            // const snackBarRef = this._snackBar.openFromComponent(CustomSnackbarComponent, {
            //   duration: 5000, // Adjust duration as needed
            //   horizontalPosition: 'center',
            //   verticalPosition: 'top',
            //   data: { title, message},
            //   panelClass:'custom-class1'
            // });

            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }
  private memberbookingstatuschangedsubscription: Subscription =
    new Subscription();
  listenForMemberBookingStatusUpdate() {
    this.memberbookingstatuschangedsubscription = this.notificationService
      .getNotificationByType("memberBookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only

            this._apiservice.getTodaysBookingsForDashboard("4", "1");

            // const snackBarRef = this._snackBar.openFromComponent(CustomSnackbarComponent, {
            //   duration: 5000, // Adjust duration as needed
            //   horizontalPosition: 'center',
            //   verticalPosition: 'top',
            //   data: { title, message},
            //   panelClass:'custom-class1'
            // });

            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }
  private memberBookingAssignmentsubscription: Subscription =
    new Subscription();
  listenForMemberBookingAssignmentUpdates() {
    this.memberBookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onMemberAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only

            this._apiservice.getTodaysBookingsForDashboard("4", "1");

            // const snackBarRef = this._snackBar.openFromComponent(CustomSnackbarComponent, {
            //   duration: 5000, // Adjust duration as needed
            //   horizontalPosition: 'center',
            //   verticalPosition: 'top',
            //   data: { title, message},
            //   panelClass:'custom-class1'
            // });

            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }

  private bookingStatusUpdatedsubscription: Subscription = new Subscription();
  listenForBookingStatusUpdates() {
    this.bookingStatusUpdatedsubscription = this.notificationService
      .getNotificationByType("bookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only

            this._apiservice.getTodaysBookingsForDashboard("4", "1");
          }
        }
      });
  }
  private bookingAssignmentsubscription: Subscription = new Subscription();
  listenForBookingAssignmentUpdates() {
    this.bookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onCustomerAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only

            this._apiservice.getTodaysBookingsForDashboard("4", "1");
          }
        }
      });
  }

  private memberattendancesubscription: Subscription = new Subscription();
  listenForMemberAttendance() {
    this.memberattendancesubscription = this.notificationService
      .getNotificationByType("onMemberAttendance")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only

            this._apiservice.getTodaysBookingsForDashboard("4", "1");
          }
        }
      });
  }

  ngOnDestroy(): void {
    this._apisub.unsubscribe();
    if (this.newbookingsubscription) {
      this.newbookingsubscription.unsubscribe();
    }
    if (this.bookingStatusUpdatedsubscription) {
      this.bookingStatusUpdatedsubscription.unsubscribe();
    }
    if (this.memberattendancesubscription) {
      this.memberattendancesubscription.unsubscribe();
    }
    if (this.memberbookingstatuschangedsubscription) {
      this.memberbookingstatuschangedsubscription.unsubscribe();
    }
    if (this.bookingAssignmentsubscription) {
      this.bookingAssignmentsubscription.unsubscribe();
    }
    if (this.memberBookingAssignmentsubscription) {
      this.memberBookingAssignmentsubscription.unsubscribe();
    }
  }

  bookingDetails(item: any) {
    // this._modelRef.open(CustomerBookingDetailsComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'Bookings Details',
    //     ref: this._modelRef,
    //     data: item.booking_hash,
    //   },
    // });
    this.authService.setUserRole(item.is_owner == 1 ? "owner" : "employee");
    localStorage.setItem(
      SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
      item.employee_hash_id
    );
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
      item.entity_public_hash_id
    );

    if (item.data_type == 1) {
      this.router.navigate(["booking-details"], {
        relativeTo: this.route,
        queryParams: {
          bookingHash: item.booking_hash,
          entityHash: item.business_hash,
          eph: item.entity_public_hash_id,
        },
      });
    } else if (item.data_type == 2) {
      this.router.navigate(["membership-booking-details"], {
        relativeTo: this.route,
        queryParamsHandling: "merge",
        queryParams: {
          memberHash: item.member_hash,
          isf: "0",
          entityHash: item.business_hash,
          bd: item.booking_date,
        },
      });
    } else if (item.data_type == 3) {
      this.router.navigate(["query-details"], {
        relativeTo: this.route,
        queryParamsHandling: "merge",
        queryParams: {
          queryHash: item.booking_hash,
          entityHash: item.business_hash,
          eph: item.entity_public_hash_id,
        },
      });
    }
  }

  formatTimeforquery(time: string): string {
    const [hour, minute] = time.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12; // Convert 0 or 12 to 12 for AM/PM time
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  }
  formatSchedule(schedule: any[]): string {
    return schedule
      .map((item) => {
        const weekday = this.getWeekdayString(item.weekday);
        const startTime = this.formatTimeforquery(item.start_time);
        const endTime = this.formatTimeforquery(item.end_time);
        return `${weekday}: ${startTime} - ${endTime}`;
      })
      .join(", ");
  }

  getWeekdayString(weekday: number): string {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdays[weekday - 1]; // Adjusting because weekday starts from 1
  }
}
